// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__uhGBT","link":"styles_link__YE9ew","title":"styles_title__67wvl"};